__turbopack_context__.v({
  "className": "iransans_87b75036-module__hBKrqG__className",
  "variable": "iransans_87b75036-module__hBKrqG__variable",
});
